module.exports = __webpack_public_path__ + "assets/img/moments.1cfdd71c.svg";